/* tslint:disable:no-console */

import { register } from 'register-service-worker';

type ServiceWorkerHookType = (registration: any) => void;

export class ServiceWorkerCustomHooks {

  // noinspection JSUnusedGlobalSymbols
  public static registerRegisteredHook(callback: ServiceWorkerHookType): void {
    this.registeredHooks.push(callback);
  }

  public static registerUpdatedHook(callback: ServiceWorkerHookType): void {
    this.updatedHooks.push(callback);
  }

  public static executeRegisteredHooks(registration: any): void {
    ServiceWorkerCustomHooks.registeredHooks.forEach((callback: ServiceWorkerHookType) => {
      callback(registration);
    });
  }

  public static executeUpdatedHooks(registration: any): void {
    ServiceWorkerCustomHooks.updatedHooks.forEach((callback: ServiceWorkerHookType) => {
      callback(registration);
    });
  }

  private static registeredHooks: ServiceWorkerHookType[] = [];

  private static updatedHooks: ServiceWorkerHookType[] = [];

}

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB',
      );
    },
    registered(registration) {
      ServiceWorkerCustomHooks.executeRegisteredHooks(registration);
      console.log('Service worker has been registered.');
    },
    cached() {
      console.log('Content has been cached for offline use.');
    },
    updatefound() {
      console.log('New content is downloading.');
    },
    updated(registration) {
      ServiceWorkerCustomHooks.executeUpdatedHooks(registration);
      console.log('New content is available; please refresh.');
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.');
    },
    error(error) {
      console.error('Error during service worker registration:', error);
    },
  });
}

let refreshing: boolean = false;
navigator.serviceWorker.addEventListener('controllerchange', () => {
  if (refreshing) {
    return;
  }
  refreshing = true;
  window.location.reload();
});
